<span #tooltipTrigger [attr.title]="content" [ngbTooltip]="''" [placement]="placement">
      <ng-content></ng-content>
</span>
